import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { LoanDao } from '@app/dao/loan/loan.dao';
import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import { SimulationType } from '@app/dao/simulation/simulation.interface';
import { UserService } from '@app/providers/user/user.service';
import { extractLoanApiErrorMessages } from '@app/services/loan/loan-api-error.utils';
import {
  neutralizeLoanPaliers,
  refreshLoanDiffereValidity,
  refreshLoanPaliersValidity,
} from '@app/services/loan/loan-palier.form';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest, Subject } from 'rxjs';
import { EaSimulationLoanFormBuilder } from './ea-simulation-loan-form.builder';
import { AuthentificationService } from '@app/authentification/authentification.service';

@UntilDestroy()
@Component({
  selector: 'ea-simulation-loan-form',
  templateUrl: './ea-simulation-loan-form.component.html',
  styleUrls: ['./ea-simulation-loan-form.component.scss'],
  providers: [
    {
      provide: PrFormAbstract,
      useExisting: forwardRef(() => EaSimulationLoanFormComponent),
    },
  ],
  standalone: false,
})
export class EaSimulationLoanFormComponent
  extends EaSimulationLoanFormBuilder
  implements OnInit
{
  subscriptions: any[] = [];
  loanCategories: any[] = [];
  loanTypes: any[] = [];
  doneSubject: Subject<void> = new Subject<void>();
  products: any;
  user: any;
  isConsultant: boolean;
  submitErrorMessages: string[] = [];

  constructor(
    protected formConstructor: PrFormConstructor,
    private loanDao: LoanDao,
    private simulationDao: SimulationDao,
    private authentificationService: AuthentificationService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.authentificationService.isConsultant().subscribe(consultant => {
      this.isConsultant = consultant;
    });

    if (this.isConsultant) {
      combineLatest([
        this.loanDao.searchProductsLoan({
          enabled: true,
          status: 'VALID',
          type: ['LOAN'],
        }),
      ]).subscribe(([products]) => {
        this.products = products;
      });
    }

    this.applyPaliersAvailability();
    this.form
      .get('mode')
      ?.valueChanges.pipe(untilDestroyed(this))
      .subscribe(() => this.applyPaliersAvailability());
    this.form
      .get('type')
      ?.valueChanges.pipe(untilDestroyed(this))
      .subscribe(() => this.applyPaliersAvailability());
    this.form
      .get('paliersEnabled')
      ?.valueChanges.pipe(untilDestroyed(this))
      .subscribe(enabled => {
        if (enabled === true) this.form.get('simuChoice')?.setValue(true);
        refreshLoanDiffereValidity(this.form);
      });
  }

  get isPaliersAvailable(): boolean {
    return (
      this.form.get('mode')?.value === false &&
      (this.form.get('type')?.value || 'FIX') === 'FIX'
    );
  }

  get hasPaliers(): boolean {
    return this.form.get('paliersEnabled')?.value === true;
  }

  private applyPaliersAvailability() {
    if (this.isPaliersAvailable) {
      refreshLoanPaliersValidity(this.form);
      return;
    }
    neutralizeLoanPaliers(this.form);
  }

  onSubmit() {
    this.entity.productId = this.form.get('productId').value;
    this.prFormService.loading();
    this.submitErrorMessages = [];
    this.simulationDao
      .simulate(null, SimulationType.LOAN, this.extract())
      .subscribe({
        next: success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          if (success) this.callback(success);
          this.notificationService.success('La sauvegarde a réussi');
        },
        error: errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.submitErrorMessages = extractLoanApiErrorMessages(errors);
          this.notificationService.error('La sauvegarde a échoué');
        },
      });
  }

  calculateInterestRate(
    product: number,
    duration: number,
    amountBorrowed: number,
    amountMonthly: number,
  ) {
    let amount;
    if (amountBorrowed != null) {
      amount = amountBorrowed;
    }
    if (amountMonthly != null && duration != null) {
      amount = amountMonthly * duration;
    }
    if (product != null && duration != null && amount != null) {
      let retreiveProduct: any;
      let loanRate: any;
      for (let e of this.products) {
        if (e.id == product) {
          retreiveProduct = e;
        }
      }
      loanRate = retreiveProduct.loanRate;
      loanRate.map(e => {
        if (e.minAmount <= amount) {
          if (e.minDuration <= duration) {
            this.form.get('interestRate').setValue(e.rate * 100);
          }
        }
      });
    }
  }
}
